import {apiUrl} from '../../context/context';
import {acerillAuthenticatedAxios} from './acerill-axios-instances';

const baseUrl = `${apiUrl}/feedback/v1`;

const submitFeedback = (emailAddress, message) => {
  return acerillAuthenticatedAxios
    .post(`${baseUrl}/feedback`, { emailAddress: emailAddress, message: message })
    .then(response => response.data);
};

const feedbackV1Client = {
  submitFeedback,
};

export default feedbackV1Client;
